import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false;
require('intersection-observer');

window.vue = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

window.FontAwesomeConfig = {
    searchPseudoElements: true
  }
